import React, { useEffect } from 'react';
import * as Immutable from 'immutable';
import usePoiUpdateHandler from '../../components/pointsOfInterest/usePoiUpdateHandler';
import { Label } from '../../../common/labels/labelTypes';
import { Tag as LabelPill, TagGroup as LabelGroup, TagList as LabelList } from '@milanote/roma';

type LabelElementPillsContainerProps = {
    labels?: Immutable.List<Label>;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
    filterQuery?: string;
    elementId: string;
};

const SEARCH_HIGHLIGHT_CLASS = 'search-highlight';

const LabelElementPillsContainer: React.FC<LabelElementPillsContainerProps> = ({
    labels,
    size,
    filterQuery,
    elementId,
}) => {
    const containerRef = React.useRef<HTMLDivElement | null>(null);

    const onHighlightsChanged = usePoiUpdateHandler({
        contentInnerRef: containerRef,
        elementId,
        selector: `.${SEARCH_HIGHLIGHT_CLASS}`,
    });

    useEffect(() => {
        onHighlightsChanged();
    }, [filterQuery]);

    if (!labels?.size) return null;

    return (
        <div className="LabelElementPillsContainer mb-1 mr-1" ref={containerRef}>
            <LabelGroup label="Labels list mb-1" size={size} selectionMode={'multiple'}>
                <LabelList className="flex flex-wrap gap-1">
                    {labels.map((label) => {
                        if (!label) return null;

                        const isSearchResult =
                            filterQuery && label.name.toLowerCase().includes(filterQuery.toLowerCase());
                        const tagBaseClassName = isSearchResult ? `${SEARCH_HIGHLIGHT_CLASS} ring-2 ring-search` : '';

                        return (
                            <LabelPill
                                key={label.id}
                                id={label.id}
                                color={label.color}
                                tagBaseClassName={tagBaseClassName}
                            >
                                {label.name}
                            </LabelPill>
                        );
                    })}
                </LabelList>
            </LabelGroup>
        </div>
    );
};

export default LabelElementPillsContainer;
